export default __webpack_public_path__ + "static/media/warning--soft-shoulder--g1.048f3f53.png";